/** Catálogo compartido por los pedidos técnicos y las compras de uso interno. */
export const INTERNAL_MATERIAL_PURPOSES = {
  MINOR_MATERIALS: 'minor_materials',
  PPE: 'ppe',
  OTHER: 'other',
};

export const INTERNAL_MATERIAL_PURPOSE_OPTIONS = [
  { value: INTERNAL_MATERIAL_PURPOSES.MINOR_MATERIALS, label: 'Materiales menores' },
  { value: INTERNAL_MATERIAL_PURPOSES.PPE, label: 'Elementos de protección personal' },
  { value: INTERNAL_MATERIAL_PURPOSES.OTHER, label: 'Otro' },
];
